import React from "react";

import { WebchatButton } from "src/base-components/WebchatButton";
import { Router } from "src/router/Router";

export const App: React.FC = () => {
  return (
    <div className="flex h-screen w-screen flex-col overflow-clip">
      <Router />
      <WebchatButton />
    </div>
  );
};
